<template>
  <div>
    <Dashboard_arin/>
  </div>
</template>

<script>
import Dashboard_arin from "@/components/adminArin/dashboard/Dashboard_arin";
export default {
  name: "DashboardArin",
  components: {
    Dashboard_arin
  }
}
</script>

<style scoped>

</style>
